import { useSyncExternalStore } from 'react';

const subscribers = new Set<() => void>();

function subscribe(callback: () => void) {
  subscribers.add(callback);
  return () => subscribers.delete(callback);
}

function getSnapshot() {
  // SSR-safe: se renderizar no server, não tem window
  if (typeof window === 'undefined') return '';
  return window.location.pathname;
}

function notifyAll() {
  subscribers.forEach((cb) => cb());
}

// Evita rodar em SSR
if (typeof window !== 'undefined') {
  const h = window.history;

  const originalPushState = h.pushState.bind(h);
  const originalReplaceState = h.replaceState.bind(h);

  h.pushState = (...args: Parameters<History['pushState']>) => {
    originalPushState(...args);
    notifyAll();
  };

  h.replaceState = (...args: Parameters<History['replaceState']>) => {
    originalReplaceState(...args);
    notifyAll();
  };

  window.addEventListener('popstate', notifyAll);
}

export function useCurrentPath(): string {
  return useSyncExternalStore(subscribe, getSnapshot);
}